import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function ModalFooter({
  type,
  children,
  className
}) {
  return (
    <div className={classNames('pgn__modal-footer', `modal-footer-${type}`, className)}>
      {children}
    </div>
  );
}

ModalFooter.propTypes = {
  type: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  children: PropTypes.node,
  submitButtonText: PropTypes.string,
  className: PropTypes.string,
};

ModalFooter.defaultProps = {
  type: 'basic',
  onClose: () => { },
  onSubmit: () => { },
  children: null,
  submitButtonText: null,
  className: null,
};

export default ModalFooter;
